import { combineReducers } from 'redux';
import partnerReducer from './partner_reducer';
import partnerPlanReducer from './partner_plan_reducer';

export default combineReducers({
    partnerReducer,
    partnerPlanReducer
});